/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slot_TimeInputs */

const en_slot_time = /** @type {(inputs: Slot_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

const de_slot_time = /** @type {(inputs: Slot_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uhrzeit`)
};

/**
* | output |
* | --- |
* | "Time" |
*
* @param {Slot_TimeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slot_time = /** @type {((inputs?: Slot_TimeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slot_TimeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_slot_time(inputs)
	return en_slot_time(inputs)
});